export const environment = {
  production: true,
  hmr: false,
  api: 'https://prod-gw.ganalottodo.com',
  devMode: false,
  ganalottodoUrl: 'https://www.ganalottodo.com'
};



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/environments/environment.ts